import { Button } from '../../atoms';
import { TRACKING_CONSTANT } from '../../constants';
import { usePageContext } from '../../organisms/PageContext';
import { InclusiveMessageWrapper } from './InclusiveMessage.styles';
import { InclusiveMessageProps } from './InclusiveMessage.types';

export const InclusiveMessage = (props: InclusiveMessageProps) => {
  const { INTERNAL_LINK } = TRACKING_CONSTANT;
  const { ctaText, ctaLink, target, trackingProperties } = props.editStayDetails;
  const { pageState } = usePageContext();
  const isAllInclusive = pageState?.summaryOfCharges?.isAllInclusive ?? false;
  if (!isAllInclusive) {
    return null;
  }
  return (
    <InclusiveMessageWrapper>
      <div className="icon-information"></div>
      <div>
        <div className="t-font-s">{props.message}</div>
        <Button
          isLink={true}
          href={ctaLink}
          buttonClassName={'d-block'}
          className="m-link-back-tertiary-button modify-stay-details"
          children={ctaText}
          target={target ?? '_blank'}
          trackingProperties={trackingProperties}
          linkType={INTERNAL_LINK}
          linkAriaLabel={ctaText}
        />
      </div>
    </InclusiveMessageWrapper>
  );
};
